import getCurrentRoute from 'lib/getCurrentRoute'

export default (routes, path, language) => {
  const { title } = getCurrentRoute(routes, path)
  return title[language] || ''
}
